import React, { useCallback, useContext } from 'react';

import { parseJsonToEditorStateWithInstruction } from '../../../../services/editorJS/utils';
import { Action } from '../../../../components/index';
import { ScriptEditorJSContext } from '../ScriptContext';
import CopyHandler from '../../../../services/editorJS/event-listeners/keyboard/CopyHandler';
import CopyTextInstructions from '../../../../assets/icons/copy-text-instructions.svg';

type Props = {
  script: string;
};

const CopyScriptTextAndInstructionsAction = ({ script }: Props) => {
  const { instanceEditorJs } = useContext(ScriptEditorJSContext);

  const onClick = useCallback(() => {
    if (instanceEditorJs) {
      try {
        const copyHandler = new CopyHandler({
          data: parseJsonToEditorStateWithInstruction(script),
          editor: instanceEditorJs,
        });
        copyHandler.process();
      } catch (e) {
        console.error(e);
      }
    }
  }, [script, instanceEditorJs]);

  return (
    <Action
      title="Copy text & instructions"
      icon={<img src={CopyTextInstructions} alt="copy text icon" width="14px" />}
      onClick={onClick}
    />
  );
};

export default CopyScriptTextAndInstructionsAction;
